




























































































import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import VisitorApi from '@/api/visitor.ts'
import TaskApi from '@/api/task.ts'
import ModifyManual from '@/views/AiiTasks/modifyManual.vue'
import CompanySearchTree from '@/mixins/companySearchTree'
const COMPANY_KEY = '1'
const PERSONAL_KEY = '0'

@Component({
	name: 'AiiTaskManual',
	components: {
		PageLayout,
		ModifyManual,
	},
})
export default class ModifyManualPage extends Mixins(CompanySearchTree) {
	private qrUploaded: boolean = false // 判断用户是否添加二维码图片
	private qrCodeSrc: string = '' // 二维码图片路径 用于展示
	private qrCodeBlob: any = '' // 二维码图片
	private previewing: boolean = false
	private savingBtn = '' // 正在调用保存接口的按钮类型
	private COMPANY_KEY = COMPANY_KEY
	private PERSONAL_KEY = PERSONAL_KEY
	private visible = false
	private confirmLoading = false
	private companyForm: any = {}

	private get isFromSetting() {
		// 是否为系统设置中的编辑服务手册
		return this.$route.name === 'EditManual'
	}

	private isNosenseItem(item: any) {
		return !item.title && !item.content
	}

	private emptyStuff(contentList: any) {
		for (let content of contentList) {
			if (!content.title) {
				return true
			}
			for (let item of content.itemList) {
				if (this.isNosenseItem(item)) {
					return true
				}
			}
		}
		return false
	}

	private companyModify() {
		this.visible = true
		// if (this.isFromSetting) {
		// 	this.visible = true
		// } else {
		// 	this.modifySubmit(COMPANY_KEY)
		// }
	}

	private companyModifySubmit() {
		this.companyForm.validateFields((errors: any, values: any) => {
			if (!errors) {
				this.confirmLoading = true
				this.modifySubmit(COMPANY_KEY, values, false).finally(() => {
					this.confirmLoading = false
					this.visible = false
				})
			}
		})
	}

	private modifySubmit(type: string, extraForm: any = {}, loading = true) {
		return new Promise(async (resolve, reject) => {
			let modifyManual: any = this.$refs.ModifyManual
			const modifying: boolean = modifyManual.modifyingType.length > 0
			if (modifying) {
				this.$message.error('请输入服务手册内容')
			} else if (this.emptyStuff(modifyManual.manual.contentList)) {
				this.$message.error('请输入服务手册内容')
			} else {
				if (loading) {
					this.savingBtn = type
				}

				const image = modifyManual.image
				let data = cloneDeep(modifyManual.manual)
				// 只存在url 则表示为本地打开未上传
				if (image.url && !image.id) {
					let res: any = ''
					const formData = new FormData()
					formData.append('filecontent', this.qrCodeBlob, this.qrCodeBlob.name)
					res = await VisitorApi.uploadImage({
						formData,
					})

					const picId = res.data.picId
					data.imageList[0].id = picId
					delete data.imageList[0].url
				} else if (!image.url && !image.id && !image.desc) {
					data.imageList = []
				}

				data.type = type
				Object.assign(data, extraForm)
				let res: any = await TaskApi.setTaskManual(data).catch(() => {})
				if (res && res.code === 200) {
					this.$message.success('修改成功')
					resolve(res)
					// this.$router.go(-1)
				}
			}

			this.savingBtn = ''
			reject()
		})
	}

	private showPreview() {
		this.previewing = true
	}

	private changePreview(previewing: boolean) {
		this.previewing = previewing
	}

	private uploadQrCode() {
		const input: any = this.$refs.uploadQrCode
		input.click()
	}

	private onLoad(e: any) {
		if (!e.target.files.length) {
			return
		}

		const fileReader = new FileReader()
		fileReader.readAsDataURL(e.target.files[0])
		fileReader.onload = () => {
			this.qrCodeBlob = this.dataURLtoBlob(fileReader.result, '用户手册二维码')
			this.qrCodeSrc = window.URL.createObjectURL(e.target.files[0])
		}
		this.qrUploaded = true
	}

	private dataURLtoBlob(dataurl: any, name: any) {
		const arr = dataurl.split(',')
		const mime = arr[0].match(/:(.*?);/)[1]
		const bstr = atob(arr[1])
		let n = bstr.length
		const u8arr = new Uint8Array(n)
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n)
		}
		const blob: any = new Blob([u8arr], { type: mime })
		blob.name = name
		return blob
	}

	private gotQrCode(upload: boolean) {
		this.qrUploaded = upload
	}

	public created() {
		// 公司树选择不需要全部选项
		this.needQuanBu = false
		this.companyForm = this.$form.createForm(this)
	}
}
